import { BodyMedium, ColorfulEnvelopeIcon, HeadingLarge } from '@arnold/common';
import React, { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Link, useLocation, useParams } from 'react-router-dom';
import { Loading } from '../components';
import { useSetUserSummaryNotificationsMutation } from '../generated/hooks';
import { Error } from '../reports/components/Error';

const UnsubscribeFromSummaryEmail: React.FC = () => {
  const location = useLocation();
  const params = useParams<{ token: string }>();
  const [setUserSummaryNotificationsMutation, { loading, error }] = useSetUserSummaryNotificationsMutation();
  const { i18n, t } = useTranslation('unsubscribe');

  useEffect(() => {
    setUserSummaryNotificationsMutation({
      variables: {
        on: false,
        auth: {
          reportAccessToken: params.token,
        },
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const lang = queryParams.get('lang');
    if (lang) {
      i18n.changeLanguage(lang);
    }
  }, [location, i18n]);

  if (loading) {
    return <Loading />;
  }
  if (error) {
    return <Error>{t('error')}</Error>;
  }
  return (
    <Error>
      <div className="text-center">
        <ColorfulEnvelopeIcon width={128} height={128} />
        <HeadingLarge>{t('title')}</HeadingLarge>
        <BodyMedium>
          <Trans i18nKey="unsubscribe:message" components={[<Link to="/overview/settings" />]} />
        </BodyMedium>
      </div>
    </Error>
  );
};

export default UnsubscribeFromSummaryEmail;
